// eslint-disable-next-line import/extensions -- false positive
import useSWRImmutable from 'swr/immutable';
import { useConfiguration } from "../contexts/ConfigurationProvider";
import { fetchTranslations } from "../utils";
export function useLocalizationQuery() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    disabled = _ref.disabled;
  var _useConfiguration = useConfiguration(),
    staticApiUrl = _useConfiguration.staticApiUrl,
    currentLanguage = _useConfiguration.currentLanguage,
    tenant = _useConfiguration.tenant;
  return useSWRImmutable(disabled ? null : [currentLanguage, tenant, staticApiUrl], fetchTranslations);
}